import * as React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import * as PXBCore from '@brightlayer-ui/react-components/core';
import * as MuiCore from '@mui/material';
import { DeviceProfileData } from '../../../constants/manage-device-profile-data';

export const DeviceProfileListItem: React.FC<{
    value: DeviceProfileData;
    isLast: boolean;
    onClick?: () => void;
}> = (props) => (
    <div
        data-testid="device-list-item"
        style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
    >
        <PXBCore.InfoListItem
            title=""
            hidePadding={true}
            backgroundColor={PXBColors.white[50]}
            divider={!props.isLast ? 'full' : undefined}
            subtitleSeparator="<"
            iconColor={PXBColors.gray[500]}
            // onClick={(): void =>}
            leftComponent={
                <div>
                    <MuiCore.Typography variant="body2" display="inline" style={{ lineHeight: 1.25 }}>
                        {props.value.key}
                    </MuiCore.Typography>
                    <MuiCore.Typography
                        variant="body2"
                        display="inline"
                        style={{ marginLeft: '5px', fontWeight: 400, lineHeight: 1.25 }}
                    ></MuiCore.Typography>
                </div>
            }
            rightComponent={<div style={{ display: 'flex', alignItems: 'center' }}></div>}
        />
    </div>
);
